<!-- TEMPLATE -->
<template>
  <div class="dean-widget">
    <div class="shadow">
      <div class="header">
        {{ today() }}
      </div>
      <div class="main">
        {{ header }}
      </div>
      <div class="footer">
        Nieuwe klanten
      </div>
    </div>
    <transition name="fade" mode="out-in" v-if="isLoading">
      <dean-load-overlay></dean-load-overlay>
    </transition>
  </div>
</template>
<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import { Component, Prop, Watch } from 'vue-property-decorator';
  import axios from 'axios';

  // DEAN COMPONENTS
  import {
    // COMPONENTS
    plusIcon,
    deanIcon,
    dashboardIcon,
    deanLoadOverlay,
  } from '@deanone/dean-components';

  @Component({
    components: {
      deanLoadOverlay,
      plusIcon,
      deanIcon,
      dashboardIcon,
    },
  })

  export default class NewCustomersWidget extends Vue {
    public header: string = '';
    public isLoading: boolean = true;

    public mounted() {
      axios
        .post('/-/trade/api/widgets.newMonthlyCustomers')
        .then((response) => {
          this.header = response.data.newCustomers;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }

    public today() {
      return new Date().toLocaleDateString(undefined, {
        month: 'short',
        year: 'numeric',
      });
    }
  }
</script>
<!-- STYLE -->
<style lang="scss" scoped>

  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  .dean-widget {
    background: url('../../assets/woman.jpg') 10% 100%;
    background-size: auto 100%;
    width: 100%;
    height: 100%;
    perspective: 0px;
    background-color: #FFF;
    border-radius: 10px;
    box-shadow: 0 0 0.38rem rgba(0, 0, 0, 0.2);
    overflow: hidden;
    color: #FFF;
  }

  .header {
    font-size: 2rem;
    font-weight: bold;
    padding: 1.5rem 1.5rem 0.75rem 1.5rem;
  }

  .main {
    font-size: 2.626rem;
    margin-top: 2rem;
  }

  .footer {
    font-size: 1.575rem;
    margin-top: 2rem;
  }

  .shadow {
    background: rgba(57, 57, 57, 0.6);
    height: 100%;
    width: 100%;
    position: relative;
  }

  .column {
    border: 1px solid #000;
  }

</style>
